import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class CategoryService {
  static categoryCreate = async (bodydata) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/categories/create",
        data: bodydata,

        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static categoryDetails = async (filterData,rowsPerPage, page) => {
 
    try {
      let filter = [];
      if(filterData.length){
        filterData.forEach((item)=>{
          filter.push(item)
          })
      }

      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/categories/admin/search",
        data: {
          filter: filter,
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "ASC",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let categoryDetail = response.data.data;
      return categoryDetail;
    } catch (err) {
      throw err;
    }
  };

  static categoryUpdate = async (categoryID, bodydata) => {
    try {
      let response = await axios({
        method: "put",
        baseURL: API_ORIGIN + "/categories/update/" + categoryID,
        data: bodydata,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static categoryDelete = async (categoryID) => {
    try {
      let response = await axios({
        method: "delete",
        baseURL: API_ORIGIN + "/categories/" + categoryID,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static categoryDetailsID = async (categoryID) => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/categories/get/admin/" + categoryID,
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let categoryDetailID = response.data.data;

      return categoryDetailID;
    } catch (err) {
      throw err;
    }
  };

  static categoryWiseDetails = async (selectedType) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/categories/admin/search",
        data: {
          filter: [{"type": selectedType}],
          limit: 100,
          skip: 0,
          sort: "DESC",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let categoryDetail = response.data.data;
      return categoryDetail;
    } catch (err) {
      throw err;
    }
  };
}
